export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()
	const authStore = useAuthStore()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "user/" + appendPath
	}

	nuxtApp.provide("userApiService", {
		$summary: async (successHandler) => {
			const url = buildApiUrl("summary")

			const requestOptions = {}
			requestOptions.method = "GET"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$qrInfo: async (eventId, successHandler) => {
			const url = buildApiUrl(`qr_info?event_id=${encodeURIComponent(eventId)}`)

			const requestOptions = {}
			requestOptions.method = "GET"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$updateUserInfo: async (requestBody, successHandler) => {
			const url = buildApiUrl("info")

			const requestOptions = {}
			requestOptions.method = "PATCH"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$updateUserPassword: async (requestBody, successHandler) => {
			const url = buildApiUrl(`password`)

			const requestOptions = {}
			requestOptions.method = "PATCH"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$updateUserImage: async (requestBody, successHandler) => {
			const url = buildApiUrl(`image`)

			const requestOptions = {}
			requestOptions.method = "PATCH"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},
	})
})
